import React from 'react';
import type { BusinessCapability } from '../domain/businessProfile';
import { useHasBusinessCapability } from './useEffectiveBusinessCapabilities';
import { ModuleEmptyState } from '../../../shared/ui/ModuleEmptyState';

type CapabilityGateCopy = {
  title: string;
  subtitle: string;
  testID?: string;
};

export function useCapabilityGate(
  capability: BusinessCapability,
  copy: CapabilityGateCopy,
): { allowed: boolean; blocked: React.ReactElement | null } {
  const allowed = useHasBusinessCapability(capability);
  if (allowed) {
    return { allowed: true, blocked: null };
  }
  return {
    allowed: false,
    blocked: (
      <ModuleEmptyState
        title={copy.title}
        subtitle={copy.subtitle}
        testID={copy.testID ?? `capability.${capability}.unavailable`}
      />
    ),
  };
}
